import { currenciesBySite } from '@panel/commons/helpers';

const siteId = process.env.REACT_APP_BUILD_SITE;

export const operationTypesConfig = {
  1: 'sell',
  2: 'rent',
  3: 'transfer',
  4: 'temp'
};

const defaultCurrencyByOpTypeAndPortal = {
  ZPAR: {
    1: currenciesBySite.ZPAR.USD,
    2: currenciesBySite.ZPAR.ARS,
    3: currenciesBySite.ZPAR.ARS,
    4: currenciesBySite.ZPAR.ARS
  },
  IWBR: {
    1: currenciesBySite.IWBR.BRL,
    2: currenciesBySite.IWBR.BRL,
    3: currenciesBySite.IWBR.BRL,
    4: currenciesBySite.IWBR.BRL
  },
  WIBR: {
    1: currenciesBySite.WIBR.BRL,
    2: currenciesBySite.WIBR.BRL,
    3: currenciesBySite.WIBR.BRL,
    4: currenciesBySite.WIBR.BRL
  },
  CMBR: {
    1: currenciesBySite.CMBR.BRL,
    2: currenciesBySite.CMBR.BRL,
    3: currenciesBySite.CMBR.BRL,
    4: currenciesBySite.CMBR.BRL
  },
  ICBR: {
    1: currenciesBySite.ICBR.BRL,
    2: currenciesBySite.ICBR.BRL,
    3: currenciesBySite.ICBR.BRL,
    4: currenciesBySite.ICBR.BRL
  },
  '24MX': {
    1: currenciesBySite['24MX'].MXN,
    2: currenciesBySite['24MX'].MXN,
    3: currenciesBySite['24MX'].MXN,
    4: currenciesBySite['24MX'].MXN
  },
  UBPE: {
    1: currenciesBySite.UBPE.PEN,
    2: currenciesBySite.UBPE.PEN,
    3: currenciesBySite.UBPE.PEN,
    4: currenciesBySite.UBPE.PEN
  },
  DVPE: {
    1: currenciesBySite.DVPE.PEN,
    2: currenciesBySite.DVPE.PEN,
    3: currenciesBySite.DVPE.PEN,
    4: currenciesBySite.DVPE.PEN
  },
  PLEC: {
    1: currenciesBySite.PLEC.USD,
    2: currenciesBySite.PLEC.USD,
    3: currenciesBySite.PLEC.USD,
    4: currenciesBySite.PLEC.USD
  },
  CAPA: {
    1: currenciesBySite.CAPA.USD,
    2: currenciesBySite.CAPA.USD,
    3: currenciesBySite.CAPA.USD,
    4: currenciesBySite.CAPA.USD
  }
};

export const portalsWithCreditAcceptance = ['ZPAR'];

const realEstateTypesWithCreditAcceptanceByPortal = { ZPAR: ['2', '1', '26', '2001', '5', '11', '14'] };

/**
 * Determines if credit acceptance is available for a given real estate type and operation type.
 *
 * @param {string} realEstateType - The type of real estate to check for credit acceptance.
 * @param {string} operationType - The type of operation (e.g., '1' for a specific operation).
 * @returns {boolean} Returns true if credit acceptance is available for the specified real estate type and operation type; otherwise, false.
 */
export const getIsAvailableCreditAcceptance = (realEstateType, operationType) => {
  const realEstateTypeByPortal = realEstateTypesWithCreditAcceptanceByPortal[siteId];
  if (!realEstateTypeByPortal || operationType !== '1') return false;
  return realEstateTypeByPortal.includes(realEstateType);
};

export const getCurrencyDefaultByOpType = opType => {
  return defaultCurrencyByOpTypeAndPortal[siteId][opType];
};
